export default "__VITE_ASSET__BjD4I$$O__"